import "./App.css";
import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/common/Navbar";
import Footer from "./Components/common/Footer";
import ScrollToTopButton from "./Components/common/ScrollToTopButton";

// Páginas
import Home from "./pages/Home";
import HortalicasPage from "./pages/HortalicasPage";
import LojaOnlinePage from "./pages/LojaOnlinePage";
import MorangosPage from "./pages/MorangosPage";
import TurismoPage from "./pages/TurismoPage";
import AboutPage from "./pages/AboutPage";
import CertificationsPage from "./pages/CertificationsPage";
import ContactPage from "./pages/ContactPage";
import ComponentsDemo from "./pages/ComponentsDemo";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hortalicas" element={<HortalicasPage />} />
        <Route path="/loja-online" element={<LojaOnlinePage />} />
        <Route path="/morangos" element={<MorangosPage />} />
        <Route path="/turismo" element={<TurismoPage />} />
        <Route path="/sobre" element={<AboutPage />} />
        <Route path="/certificacoes" element={<CertificationsPage />} />
        <Route path="/contato" element={<ContactPage />} />
        <Route path="/demo" element={<ComponentsDemo />} />
      </Routes>
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}

export default App;
